module.exports = __webpack_public_path__ + "media/images/icon/help-0358086550c7920245027c94eb863f22.svg";